import React from "react";
import { Spin } from "antd";
import "./IconContainer.css";

const IconContainer = ({
  loading,
  icon,
  onClick,
  iconComponent,
  iconStyle = { fontSize: "20px" },
  style = {},
  disabled = false,
}) => {
  const handleClick = (e) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={`icon-container ${disabled ? "disabled" : ""}`}
      onClick={handleClick}
      style={{
        cursor: disabled || loading ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
    >
      {loading ? (
        <Spin style={iconStyle} />
      ) : iconComponent ? (
        React.cloneElement(iconComponent, { style: iconStyle })
      ) : (
        <img src={icon} alt="icon" style={iconStyle} />
      )}
    </div>
  );
};

export default IconContainer;
